<!--
  Rendered for every client except the tenant root, not only ones that already
  have a link. The old *ngIf="client?.Organization_id" hid the card from exactly
  the clients that needed it.
-->
<nb-card *ngIf="linkable" class="org-section">
    <nb-card-header>{{ 'linkedorganization' | translate }}</nb-card-header>
    <nb-card-body>
        <div *ngIf="loading">{{ 'loading' | translate }}</div>
        <div *ngIf="errorMessage" class="error-banner">{{ errorMessage }}</div>

        <!--
          Branches on whether the link EXISTS, not on whether it loaded. The
          body needs org; the controls do not. A linked client whose org fails
          to fetch would otherwise show the error banner and nothing else, so
          the one state where the link is provably broken would be the one
          state offering no way to fix it.
        -->
        <div *ngIf="client?.Organization_id && !picking && !loading">
            <ng-container *ngIf="org">
                <h6>{{ org.canonical_name }}</h6>
                <p class="meta">
                    <span>{{ org.aliases_count ?? org.aliases?.length ?? 0 }} {{ 'aliases' | translate }}</span>
                    <span class="dot">·</span>
                    <span>{{ org.market_vacancies_count ?? 0 }} {{ 'scrapedvacancies' | translate }}</span>
                </p>
                <bst-organization-aliases *ngIf="org.aliases?.length" [aliases]="org.aliases" [canonicalName]="org.canonical_name"></bst-organization-aliases>
            </ng-container>
            <div class="org-actions">
                <button nbButton size="small" type="button" (click)="startPicking()" [disabled]="saving">
                    {{ 'changeorganization' | translate }}
                </button>
                <button nbButton size="small" status="danger" type="button" (click)="clear()" [disabled]="saving">
                    {{ 'removeorganizationlink' | translate }}
                </button>
            </div>
        </div>

        <!--
          The unlinked state. Same control and inputs as the "+ New client"
          dialog, so the search behaves identically. [addnew] is omitted: that
          hook creates a blank Client, which is meaningless when the Client
          already exists and is the thing being linked.
        -->
        <div *ngIf="!client?.Organization_id && !picking" class="org-empty">
            <p class="meta">{{ 'noorganizationlinked' | translate }}</p>
            <button nbButton size="small" status="primary" type="button" (click)="startPicking()" [disabled]="saving">
                {{ 'linkorganization' | translate }}
            </button>
        </div>

        <div *ngIf="picking" class="org-picker">
            <bst-list-adder
                target="organization"
                [autolist]="true"
                [single]="true"
                [saveunknown]="false"
                [formControl]="pickerControl"
                [placeholder]="'searchorg' | translate">
            </bst-list-adder>
            <!--
              The picked organisation already belongs to another client: the
              same company entered twice (#1849). Offer the merge here, where
              the user found the duplicate, instead of a dead-end error.
            -->
            <div *ngIf="mergeOffer" class="merge-offer">
                <p>
                    <strong>{{ mergeOffer.from.name }}</strong> {{ 'mergeofferexists' | translate }}
                    <span *ngIf="mergeOffer.summary" class="meta">{{ 'mergeoffersummary' | translate:mergeOffer.summary }}</span>
                </p>
                <p *ngIf="mergeOffer.refusal" class="error-banner">{{ 'mergerefused' | translate }} {{ mergeOffer.refusal }}</p>
                <ng-container *ngIf="!mergeOffer.refusal">
                    <p *ngIf="isAdmin" class="meta">{{ 'mergeofferhint' | translate:{name: mergeOffer.from.name} }}</p>
                    <p *ngIf="!isAdmin" class="meta">{{ 'mergeaskadmin' | translate }}</p>
                    <a [routerLink]="['/clients', mergeOffer.from.id]">{{ 'mergeopenother' | translate }}</a>
                </ng-container>
            </div>

            <div class="org-actions">
                <button nbButton size="small" type="button" (click)="cancelPicking()" [disabled]="saving">
                    {{ 'cancel' | translate }}
                </button>
                <button *ngIf="mergeOffer && !mergeOffer.refusal && isAdmin" nbButton size="small" status="danger" type="button" (click)="merge()" [disabled]="saving">
                    {{ (confirmingMerge ? 'mergeconfirm' : 'mergeintothis') | translate:{name: mergeOffer.from.name} }}
                </button>
                <button *ngIf="!mergeOffer" nbButton size="small" status="success" type="button" (click)="link()" [disabled]="!picked || saving">
                    {{ 'save' | translate }}
                </button>
            </div>
        </div>
    </nb-card-body>
</nb-card>
